import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'addLinkButtonDescription'
	| 'addLinkButtonText'
	| 'addMenuButtonDescription'
	| 'addMenuButtonText'
	| 'menuSubItemCreationDisabledTooltipText';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		addLinkButtonText: {
			id: 'company-hub.links-menu-extension.config-panel.add-link-button.text',
			defaultMessage: 'Link',
			description:
				'Text for add link button that pops up after the user click the add New Item button on the Links Menu configuration panel',
		},
		addLinkButtonDescription: {
			id: 'company-hub.links-menu-extension.config-panel.add-link-button.description',
			defaultMessage: 'Add important links',
			description:
				'Description for add link button that pops up after the user click add the New Item button on the Links menu configuration panel',
		},
		addMenuButtonText: {
			id: 'company-hub.links-menu-extension.config-panel.add-menu-button.text',
			defaultMessage: 'Menu',
			description:
				'Text for add menu button that pops up after the user click the add New Item button on the Links menu configuration panel',
		},
		addMenuButtonDescription: {
			id: 'company-hub.links-menu-extension.config-panel.add-menu-button.description',
			defaultMessage: 'Group related links together',
			description:
				'Description for add menu button that pops up after the user click add the New Item button on the Links menu configuration panel',
		},
		menuSubItemCreationDisabledTooltipText: {
			id: 'company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text',
			defaultMessage: 'You have reached the maximum number of nested levels.',
			description:
				'Popup message that shows when user hovers over a disabled add menu button explaining that it has reached the maximum number of nested levels and therefore cannot create anymore menu items',
		},
	});

export default message;
